<template>
  <div id="rooms-create">
    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <Button
            v-if="routeType"
            :disabled="disableSaveButton"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            class="page-actions--button"
            @click="createRoom()"
          >
            Salvar
          </Button>
          <Button
            v-else
            :disabled="disableSaveButton"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            class="page-actions--button"
            @click="editRoom()"
          >
            Salvar
          </Button>
          <Button
            layout="outline"
            class="page-actions--button"
            @click="$router.push({ name: 'AgrupadorQuartosListagem' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            v-if="!routeType"
            variation="error"
            class="page-actions--button"
            @click.stop.prevent="deleteModal($route.params.id)"
          >
            Excluir
          </Button>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>
          <Paragraph class="page-actions--tip-text">
            Crie grupos para facilitar a análise dos dashboards, fazendo um
            compilamento das informações para análises de forma geral. <br />
            <br />
            Exemplo: Ao analisar um determinado grupo de quartos, é possível ver
            no detalhe o comportamento de compra e resultados.
          </Paragraph>
        </SidebarBlock>
      </template>

      <!-- FORMULÁRIO -->
      <template #content>
        <span class="form">
          <FormInput
            v-model="nome"
            :error="error.nome"
            :showErrorFeedbackMessage="true"
            :required="true"
            label="Nome do agrupador"
            placeholder="Insira o nome do agrupador"
            class="text-input--email large"
          />
        </span>

        <span class="form">
          <PmwSelectionBox
            v-model="selectedItems"
            :list="options"
            :required="true"
            placeholder="Busque pelo nome da quarto"
            selectedPlaceholder="Busque pelo nome da quarto selecionada"
            titleFirstBox="Adicionar quartos do grupo"
            titleSecondBox="Quartos selecionados"
          >
            <template #empty-text>
              <p class="empty-text">
                Nenhuma quarto selecionado para esse grupo de quartos.<br />
              </p>
            </template>
          </PmwSelectionBox>
          <hr class="horizontal-line" />
        </span>

        <!-- FOOTER -->
        <span class="bottom-buttons">
          <Button
            layout="outline"
            class="bottom-buttons--return"
            @click="$router.push({ name: 'AgrupadorQuartosListagem' })"
          >
            Voltar sem salvar
          </Button>
          <Button
            v-if="routeType"
            :disabled="disableSaveButton"
            :tooltipText="
              'Para salvar, preencha os campos obrigatórios sinalizados com *'
            "
            :popperStrategy="'auto'"
            class="bottom-buttons--save"
            @click="createRoom()"
          >
            Salvar
          </Button>
          <Button
            v-else
            :disabled="disableSaveButton"
            class="bottom-buttons--save"
            @click="editRoom()"
          >
            Salvar
          </Button>
        </span>
      </template>
    </SidebarLayout3>

    <!-- MODAL DELEÇÃO -->
    <AlertModal
      v-model="showDeleteModal"
      :buttonClose="true"
      title="Excluir agrupador de quartos"
      @alert-modal-cancel="cancelDisable()"
      @alert-modal-confirm="disableRoom()"
    >
      <template #text>
        Ao excluir esse agrupador, não será mais possível visualizar as
        informações contidas nele de forma compilada em relatórios. <br />
        Tem certeza de que quer fazer isso?
      </template>
    </AlertModal>
  </div>
</template>

<script>
/** Componentes da lib */
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import PmwSelectionBox from '@solucoes/components-lib-tmp/src/components/patterns/PmwSelectionBox'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'

/** Imports do projeto */
import SidebarLayout3 from '@/layouts/SidebarLayout3'

export default {
  name: 'roomBundlerCreate',
  components: {
    Button,
    FormInput,
    Heading,
    SidebarLayout3,
    AlertModal,
    PmwSelectionBox,
    SidebarBlock,
    Paragraph
  },
  data() {
    return {
      options: [] /** Opções de quartos */,
      selectedItems: [] /** Array de itens selecionados */,
      nome: '' /** Nome do grupo */,
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Agrupador de quartos',
          url: '/Admin/v2/agrupador-quartos'
        },
        {
          label: 'Criar novo agrupador de quartos'
        }
      ],
      /** Guarda tipo de página (Edição/Criação)  */
      routeType: '',
      /** Título da página  */
      pageTitle: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      /** Guarda Id para deleção */
      roomDelete: null,
      /** Guarda Id da quarto */
      roomId: null,
      /** Controle de erro */
      error: {
        nome: false
      },
      firstLevelList: null,
      childValue: null
    }
  },
  computed: {
    disableSaveButton() {
      if (this.nome !== '' && this.selectedItems.length !== 0) {
        return false
      }
      return true
    }
  },
  watch: {
    /** Controle de erro de nome */
    nome: {
      handler: function() {
        if (this.nome !== '') {
          this.error.nome = false
        } else {
          this.error.nome = true
        }
      },
      deep: true
    }
  },
  created() {
    /** Get de métodos */
    this.pageType()
    this.getRooms()
  },
  methods: {
    /** Verifica se é edição ou criação */
    pageType() {
      if (this.$route.name === 'AgrupadorQuartosCriar') {
        this.routeType = true
        this.pageTitle = 'Criar novo agrupador de quartos'
      } else {
        this.routeType = false
        this.getSingleRoom()
      }
    },

    /** verificar se dado existe */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Retorna dados do usuário */
    getSingleRoom() {
      this.$room.getRoomBundlers(this.$route.params.id).then((response) => {
        this.nome = response.data.nome
        const returnData = response.data.quartos

        returnData.forEach((dados) => {
          const data = {
            codigo: dados.codigo,
            descricao: dados.nome.trim(),
            ativo: true,
            text: dados.nome.trim(),
            id: dados.codigo,
            numeroAdultos: dados.maximoAdultos,
            numeroCriancas: dados.maximoCriancas,
            nome: dados.nome,
            base: dados.base
          }

          this.selectedItems.push(data)
        })

        this.breadcrumb = [
          {
            label: 'Configurações'
          },
          {
            label: 'Agrupador de quartos',
            url: '/Admin/v2/agrupador-quartos'
          },
          {
            label: `Editando ${this.nome}`
          }
        ]
        this.pageTitle = 'Editando ' + this.nome
      })
    },

    /** Edição de usuário */
    editRoom() {
      if (this.nome === null && !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      const quartosIDs = this.selectedItems.map((item) => {
        return parseInt(item.codigo)
      })

      this.$room
        .editRoom({
          nome: this.nome,
          quartos: quartosIDs,
          codigo: parseInt(this.$route.params.id)
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de quartos editado com sucesso'
          })
          this.$router.push({ name: 'AgrupadorQuartosListagem' })
        })
        .catch((err) => {
          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
    },

    /** Cria uma nova receita */
    createRoom() {
      if (this.nome === null && !this.selectedItems.length) {
        return this.$bus.$emit('show-alert-chip', {
          message: 'Por favor, preencha todos os campos obrigatórios'
        })
      }

      /** Tratamendo de dados para envio de Grupos */
      const quartosIDs = this.selectedItems.map((item) => {
        return parseInt(item.codigo)
      })

      this.$room
        .createRoom({
          nome: this.nome,
          quartos: quartosIDs
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de quartos criado com sucesso'
          })
          this.$router.push({ name: 'AgrupadorQuartosListagem' })
        })
        .catch((err) => {
          this.$bus.$emit('show-alert-chip', {
            message: err.messages[0]
          })
        })
    },

    /** Chamada para deletar usuário */
    disableRoom() {
      this.$room
        .disableRoom({ agrupadores: [parseInt(this.roomDelete)] })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de quartos excluido com sucesso'
          })
          this.$router.push({ name: 'AgrupadorQuartosListagem' })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de quartos'
          })
        })
    },

    /** Retorna dados do usuário */
    getRooms() {
      this.$room.getAllRooms(true).then((response) => {
        this.firstLevelList = response.data
        this.firstLevelList.forEach((dados) => {
          const data = {
            label: dados.nome.trim(),
            id: dados.codigo,
            options: dados.quartos
          }
          const childrenData = data.options
          childrenData.map(function(key, index) {
            childrenData[index]['text'] = key.nome.trim()
            childrenData[index]['id'] = key.codigo
            childrenData[index]['descricao'] = key.nome.trim()
          })

          this.options.push(data)
        })
      })
    },

    /** Controle de deleção */
    deleteModal(roomId) {
      this.showDeleteModal = true
      this.roomDelete = roomId
    },

    /** Controle de cancelamento de deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.roomDelete = null
    }
  }
}
</script>

<style lang="scss" scoped>
.large {
  width: 270px;
}
.medium {
  width: 150px;
}
.small {
  width: 56px;
}
.sidebar-title {
  margin-top: 40px;
  margin-left: 20px;
  margin-bottom: 15px;
}
.sidebar-buttons {
  width: 215px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: auto;
}
.horizontal-line {
  margin: 45px auto 45px;
}
.text-input {
  &--email {
    margin-top: 37px;
    margin-right: 35px;
  }
  &--limit {
    width: 141px;
  }
}
.form {
  display: block;
  gap: 20px;
  margin-bottom: 60px;
}

.select {
  width: 340px;

  &--small {
    width: 55px;
  }
  &--medium {
    width: 150px;
  }
}
.bottom-buttons {
  display: flex;
  justify-content: space-between;
  &--return,
  &--save {
    width: 215px;
  }
}
::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}
::v-deep .content--white_card {
  padding: {
    top: 20px;
  }
}
.page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
  &--tip-text {
    color: #474747;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
}
</style>
